<template>
    <div>
        <search-item @updateFormData="updateFormData"></search-item>
        <div class="jobs">
            <div v-if="datas && datas.length>0" class="jobs-content flex">
                <div>
                    <div v-for="(item,index) in datas" 
                      :key="index" 
                      class="jobs-item boxShadow"
                      :class="item.id==currentID?'active':''"
                      @click="dealDetail(item)">
                        <div class="flexBetween jobs-item-title">
                            <p class="textOver">{{ item.name}}</p>
                            <p class="shrink">{{item.salaryRangeName}}</p>
                        </div>
                       
                        <div class="flex" style="flex-wrap: wrap;">
                            <Btns v-if="item.workExperienceName" class="shrink" :value="item.workExperienceName"/> 
                            <Btns v-if="item.qualificationsName" class="shrink" :value="item.qualificationsName"  /> 
                            <Btns v-if="item.financeTypeName" class="shrink" :value="item.financeTypeName"/>
                        </div>
                        <p class="shrink uptime" >{{ item.address }}</p>
                    
                    </div>
                    <pagination
                        :total="pagination.totalRow"
                        v-model="pageIndex"
                        v-if="pagination.totalRow>0 "
                        @change="pageChange">
                    </pagination>
                    <prompt v-if="datas.length < 1"></prompt>
                </div>

                <!-- <scrollactive class="myresume-aside-stepmenu-content" :offset="0"> -->
                <div class="jobs-content-detail ">
                    <div class="boxShadow jobs-content-detail-top">
                        <div class="flexBetween jobs-content-detail-title">
                            <div class="flex jobs-item-title" style="width: 70%;">
                                <p class="textOver" style="padding-right: 16px;">{{ currentItemData.name}} </p>
                                <p class="shrink">{{currentItemData.salaryRangeName}}</p>
                            </div>
                            <div class="flex shrink jobs-content-detail-opeart">
                                <div type="text" class="opeartBtn isready" v-if="currentItemData.delivery">已申请内推</div>
                                <div class="opeartBtn" v-else @click="sendResume(currentItemData.id)">申请内推</div>

                                <div class="collect" 
                                    :class="currentItemData.favorite?'content-box-collected':''" 
                                    @click="collectJob(currentItemData.id,currentItemData.favorite)"> 
                                    <span v-if="currentItemData.favorite" class="fonticon">&#xe623;</span>
                                    <span v-else class="fonticon">&#xe62f;</span>
                                    {{currentItemData.favorite?'取消收藏':'未收藏'}}
                                </div>
                            </div>
                        </div>
                      
                            <div v-if="shlefInfo" class="flexColumn itemsEnd">
                                <div
                                class="chooseResume textOver"
                                @click="chooseResume(index)"
                                v-for="(item, index) in resumeList"
                                :key="index"

                                >
                                <span class="fonticon" v-if="resumeIndex == index">&#xe637;</span>
                                <span class="fonticon" v-else>&#xe607;</span>

                                <span class="fonticon" v-if="index == 0">&#xe64a;</span>
                                <span class="fonticon" v-else>&#xe65d;</span>

                                <span class="resume-name">{{ item.fileName }}</span>
                                </div>
                            </div>
                       
                        
                        <!-- <div style="padding-bottom: 10px;">
                            <Btns class="shrink" :value="currentItemData.workExperienceName"/> 
                            <Btns class="shrink" :value="currentItemData.qualificationsName"  /> 
                            <Btns class="shrink" :value="currentItemData.address" />
                        </div> -->
                        
                        <p class="text-subtitle">岗位职责</p>
                        <div class="text-content" v-html="currentItemData.desc"></div>

                        <div class="text-title">工作要求</div>
                        <p class="text-subtitle">业务技能要求</p>
                        <div class="text-content" v-html="currentItemData.requirements"></div>
                        <p v-if="currentItemData.hardCondition" class="text-subtitle">硬性要求</p>
                        <div v-if="currentItemData.hardCondition" class="text-content" v-html="currentItemData.hardCondition"></div>
                    </div>
                    <div class="boxShadow jobs-content-detail-bottom">
                        <div class="text-title">工作地点</div>
                        <p class="text-subtitle">公司地址：{{ currentItemData.addressDetail }}</p>
                        <address-map :location="location" :componentMarker="componentMarker"></address-map>
                    </div>
                </div>
            <!-- </scrollactive> -->
            </div>
            <prompt v-else></prompt>
        </div>

    </div>
  </template>
  
  <script>
 import SearchItem from './searchItem.vue';
 import Btns from '../../../components/Btn.vue';
 import AddressMap from '../../../components/addressMap.vue';
 import { mapGetters,mapActions,mapState } from 'vuex'
// import { set } from 'vue/types/umd';
  export default {
    props: {
        datas:{
            type:Array,
            default:()=>{}
        },
        pagination:{
            type:Object,
            default:()=>{}
        },
        pageIndex:{
            type:Number,
            default:1
        }

        
    },
    data() {
      return {
        currentID:null,
        currentItemData:{},
        location: [],
        componentMarker: {
          //地图坐标标注的点位
          position: [],
          content: "腾讯大厦",
          offset: [0, -26]
        },
        resumeIndex: 0, //选择的简历下标
        resumeList: [], //简历列表
        pushLoading: false,
        fullloading:null
        

        
     };
    },
    created(){
        
        // if(this.datas && this.datas.length>0){
        //     this.currentID =  this.datas[0].id;
        //     this.currentItemData = this.datas[0];
        //     this.componentMarker.position = [this.currentItemData.longitude, this.currentItemData.latitude];
        //     this.componentMarker.content = this.currentItemData.companyName;
        //     this.location = [this.currentItemData.longitude, this.currentItemData.latitude];
        // }
    },
    mounted(){},
    computed:{
        ...mapState({
            shlefInfo: state => state.user.info //个人信息
      }),
        ...mapGetters(["isLogin"]),
    },
    components: {SearchItem,Btns,AddressMap},
    methods: {
        ...mapActions([
            "accessoryResume",
            "sendOnlineResume",
            "sendAttachmentResume",
        ]),



        
        updateFormData(data){
           this.$emit('upJobsearch',data)
        },
        dealDetail(item){
            this.currentID=item.id;
            this.currentItemData = item;
            this.componentMarker.position = [this.currentItemData.longitude, this.currentItemData.latitude];
            this.componentMarker.content = this.currentItemData.companyName;
            this.location = [this.currentItemData.longitude, this.currentItemData.latitude];
        },
        //职位的收藏与取消
        collectJob(id,collect){
            this.$emit('updateFavorite',id,collect)
        },
        pageChange(e){
            this.$emit('updatePage',e)
        },
         // 获取附件简历
        async getAccessoryResume() {
            const res = await this.accessoryResume();
            res.data.unshift({
                id: "",
                fileName: "在线简历"
            });
            this.resumeList = res.data;
        },
         // 选择简历
      async chooseResume(index) {
        this.resumeIndex = index;
      },
      // 投递简历
      async sendResume(id) {
        if(this.isLogin){
          // 投递在线简历
          this.pushLoading = true;
          // 打印的是当前已投递次数，下面两个TODO都是需要处理的
          // console.log(this.shlefInfo.positionStatistics.deliveredDay)
          if (this.resumeIndex == 0) {
            const confirmRes = await this.$confirm(
              `你当前投递的是在线简历，且今日已经申请内d推了(${this.shlefInfo.positionStatistics.deliveredDay})次,你确定申请内推吗？`,
              "提示",
              {
                cancelButtonText: "放弃内推",
                confirmButtonText: "申请内推",
                type: "warning"
              }
            );
            if (confirmRes !== "confirm") {
              return false;
            }
            this.fullloading = this.$loading({
              lock: true,
              text: "职位内推中...,请耐心等待",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            const res = await this.sendOnlineResume(id);
            this.fullloading.close();
            if (res.code != 200) {
              let codes=[95070,95073,95076,95075,95077,95078]
              if (res.code == 98010) {
                this.$router.push("/login");
              } else if(codes.includes(res.code)){
                this.$confirm( `${res.message} `, '提示',{
                  confirmButtonText: '完善简历',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  this.$router.push("/myresume");
                }).catch(()=>{})
              }
              else {
                this.$message({
                  message: res.message,
                  type: "warning"
                });
              }
            } else {
              if (res.data && res.data.type) {
                this.editJump(res.data);
                return false;
              }
              this.$emit('updateDelivery',id)
              //await this.getDetail();
              this.$message({
                message: "申请成功",
                type: "success"
              });
            }
          } else {
            // 投递附件简历
            const fileName = this.resumeList[this.resumeIndex].fileName;
            const confirmRes = await this.$confirm(
              `你当前投递的是附件简历（${fileName}），且今日已经申请内推了${this.shlefInfo.positionStatistics.deliveredDay}次,你确定申请内推吗？`,
              "提示",
              {
                cancelButtonText: "放弃内推",
                confirmButtonText: "申请内推",
                type: "warning"
              }
            );
            if (confirmRes !== "confirm") {
              return false;
            }
            this.fullloading = this.$loading({
              lock: true,
              text: "职位内推中...,请耐心等待",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            const res = await this.sendAttachmentResume({
              positionId: id,
              resumeId: this.resumeList[this.resumeIndex].id
            });
            this.fullloading.close();
            if (res.code != 200) {
              let codes=[95070,95073,95076,95075,95077,95078]
              if (res.code == 98010) {
                this.$router.push("/login");
              } else if(codes.includes(res.code)){
                this.$confirm( `${res.message} `, '提示',{
                  confirmButtonText: '完善简历',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(()=>{
                  this.$router.push("/myresume");
                }).catch(()=>{})
              }else {
                this.$message({
                  message: res.message,
                  type: "warning"
                });
              }
            } else {
              if (res.data && res.data.type) {
                this.editJump(res.data);
                return false;
              }
              this.$emit('updateDelivery',id)
             // await this.getDetail();
              this.$message({
                message: "申请成功",
                type: "success"
              });
            }
          }
          this.pushLoading = false;
        }else{
          this.$router.push("/login");
        }
      },
      async editJump(data) {
        await this.$confirm(data.typeDesc, "提示", {
          cancelButtonText: "放弃内推",
          confirmButtonText: "前往完善",
          type: "warning"
        });
        let isEdit = "1";
        let id = "";
        switch (data.type) {
          case 11:
            isEdit = "1";
            break;
          case 21:
            isEdit = "2";
            break;
          case 31:
            isEdit = "3";
            break;
          case 40:
            isEdit = "4";
            break;
          case 41:
            isEdit = "4";
            id = data.eduId;
            break;
          case 50:
            isEdit = "5";
            break;
          case 51:
            isEdit = "5";
            id = data.workId;
            break;
          case 60:
            isEdit = "6";
            break;
          case 61:
            isEdit = "6";
            id = data.projectId;
            break;
        }
        this.$router.push({
          path: "/myresume",
          query: {
            isEdit,
            id
          }
        });
      }
    },
    watch:{
        datas:{
            handler(){
                if(this.datas && this.datas.length>0){
                    this.currentID =  this.datas[0].id;
                    this.currentItemData = this.datas[0];
                    this.componentMarker.position = [this.currentItemData.longitude, this.currentItemData.latitude];
                    this.componentMarker.content = this.currentItemData.companyName;
                    this.location = [this.currentItemData.longitude, this.currentItemData.latitude];
                }
            },
            immediate:true,
            deep:true,
        },
        isLogin:{
            handler(){
                if(this.isLogin){
                    this.getAccessoryResume();
                }
            },
            immediate:true
        }
        
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $mianColor:#287CF3;
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
    .mian{
        border-radius: 0 0 6px 6px;
    }
    .jobs{
        margin-top: 20px;
        // background: $whiteColor;
        &-content{
            position: relative;
            transition: all .2s linear;
            &-detail{
                position: sticky;
                top: 66px;
                margin-left: 20px;
                // top: 0;
                // 
                // left: 416px;
                width: 864px;
                max-height: 700px;
                overflow-y: auto;
                // padding: 24px;
                .boxShadow{
                    padding: 24px;
                    background: $whiteColor;
                }
                &-title{
                    flex-wrap: nowrap;
                    align-items: center;
                    
                }
                &-opeart{ 
                    padding-bottom: 10px;
                    .collect{
                        width: 100px;
                        height: 36px;
                        text-align: center;
                        line-height: 36px;
                        box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
                        border-radius: 6px;
                        border: 1px solid #287CF3;
                        font-size: 14px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        margin-left: 20px;
                        cursor: pointer;
                        color: #287CF3;
                    }
                }
                &-top{
                    margin-bottom: 20px;
                    .text-content{
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #333333;
                        line-height: 24px;
                        font-size: 14px;
                    }
                    .jobs-item-title{
                        p{
                            font-size: 22px !important;
                        }
                        
                        flex-wrap: nowrap;
                    }

                    
                    
                }
                .text-title{
                        font-size: 18px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 25px;
                        padding: 20px 0 8px ;
                        border-bottom: 1px solid  #EBEBEB;
                    }
                    .text-subtitle{
                        font-size: 16px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 22px;
                        padding: 8px 0;
                    }
            }
        }
        &-item{
            width: 394px;
            margin-bottom: 20px;
            background: $whiteColor;
            padding: 20px;
            border: 1px solid $whiteColor;
            transition: all .2s linear;
            cursor: pointer;
            .flexBetween{
                flex-wrap: nowrap;
            }
            &-title{
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: $fontCol;
                padding-bottom: 10px;
                p{
                    &:last-child{
                        font-size: 16px;
                        color:  $yellowColor;
                    }
                }
            }
            .uptime{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color:  $secondfontCol;
                text-align: right;
            }
        }
        .active{
            transition: all .2s linear;
            border: 1px solid $mianColor;
            box-shadow: 0 20px 16px 0 hsla(0,0%,70.2%,.2);
            .textOver{
                color: $mianColor;
            }
        }
        .opeartBtn{
          cursor: pointer;
            width: 148px;
            height: 36px;
            line-height: 36px;
            background: #287CF3;
            box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            margin-bottom: 16px;
          
        }
        .isready{
          background-color: #c8c9cc;
        }
        .chooseResume{
          width: 260px;
          padding-bottom: 6px;
          .fonticon{
            padding-left: 6px;
            cursor: pointer;
          }
          .resume-name{
            padding-left: 2px;
          }
        }
    }

  </style>
  